import Vue from 'vue'

Vue.component('LeadTimeline', () => import('./Timeline.vue'))
Vue.component('LeadMoveForms', () => import('./MoveForms.vue'))
Vue.component('TransferLead', () => import('./Transfer.vue'))
Vue.component('ConvertToOpv', () => import('./ConvertToOpv.vue'))